import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../../lib/api";
import { useQueryClient } from "@tanstack/react-query";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const queryClient = useQueryClient();

  useEffect(() => {
    const loadUser = () => {
      const token = localStorage.getItem("company_token");
      const userData = localStorage.getItem("user_data");

      if (token && userData) {
        try {
          setUser(JSON.parse(userData));
        } catch (error) {
          console.error("Failed to parse user data", error);
          localStorage.removeItem("user_data");
          localStorage.removeItem("company_token");
        }
      }
      setLoading(false);
    };

    loadUser();
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/user/login", { email, password });
      if (data.success) {
        const token = data.data.token;
        const userData = data.data.user;

        localStorage.setItem("company_token", token);
        localStorage.setItem("user_data", JSON.stringify(userData));

        // Store role and permissions separately
        const role = userData?.role || "";
        const permissions = Array.isArray(userData?.permissions) ? userData.permissions : [];
        
        localStorage.setItem("user_role", role);
        localStorage.setItem("user_permissions", JSON.stringify(permissions));

        setUser(userData);
        queryClient.invalidateQueries();
        return { success: true };
      }
    } catch (err) {
      return { success: false, message: err.response?.data?.message || "Login failed" };
    }
  };

  const logout = () => {
    localStorage.removeItem("company_token");
    localStorage.removeItem("user_data");
    localStorage.removeItem("user_role");
    localStorage.removeItem("user_permissions");
    setUser(null);
    queryClient.clear();
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};